<template>
    <div class="row">
        <!-- Cards -->
        <div class="col-12 col-lg-8">
            <!-- Datos Generales -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'info-circle']" :class="['mr-2']" /> General
                    </h5>
                </div>

                <div :class="['card-body', $style.generalCard]">
                    <div class="row mb-4">
                        <div class="col-6 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'align-justify']" class="mr-1" /> Alias:</h5>
                            <skeleton-text :value="client.alias" :loading="loading" />
                        </div>
                        <div class="col-6 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'align-justify']" class="mr-1" /> Nombre:</h5>
                            <skeleton-text :value="client.name" :loading="loading" />
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <h5><fa-icon :icon="['fal', 'align-justify']" class="mr-1" /> Razón Social:</h5>
                            <skeleton-text :value="client.legal_name" :loading="loading" />
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-6 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'phone-office']" class="mr-1" /> Teléfono fijo:</h5>
                            <skeleton-text :value="client.phone" :loading="loading" />
                        </div>
                        <div class="col-6 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'mobile']" class="mr-1" /> Teléfono móvil:</h5>
                            <skeleton-text :value="client.mobile_phone" :loading="loading" />
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <h5><fa-icon :icon="['fal', 'id-card']" class="mr-1" /> CIF:</h5>
                            <skeleton-text :value="client.cif" :loading="loading" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h5><fa-icon :icon="['fal', 'envelope']" class="mr-1" /> Email:</h5>
                            <skeleton-text :value="client.email" :loading="loading">
                                <a-tooltip placement="top">
                                    <template slot="title">
                                        <fa-icon :icon="['fal', 'paper-plane']" class="mr-2" /> Enviar email
                                    </template>
                                    <a :href="`mailto:${client.email}`">{{ client.email }}</a>
                                </a-tooltip>
                            </skeleton-text>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Datos geograficos -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'map-marker']" :class="['mr-2']" /> Datos Geográficos
                    </h5>
                </div>
                <div :class="['card-body', $style.generalCard]">
                    <div class="row mb-4">
                        <div class="col-12">
                            <h5><fa-icon :icon="['fal', 'map-location-dot']" class="mr-1" /> Domicilio Social:</h5>
                            <skeleton-text :value="client.address" :loading="loading" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6 col-lg-3 mb-4 mb-lg-0 align-items-left">
                            <h5><fa-icon :icon="['fal', 'flag']" class="mr-1" /> Localidad:</h5>
                            <skeleton-text :value="client.location" :loading="loading" />
                        </div>
                        <div class="col-6 col-lg-3 mb-4 align-items-left">
                            <h5><fa-icon :icon="['fal', 'flag']" class="mr-1" /> Provincia:</h5>
                            <skeleton-text :value="client.state" :loading="loading" />
                        </div>
                        <div class="col-6 col-lg-3 align-items-left">
                            <h5><fa-icon :icon="['fal', 'hashtag']" class="mr-1" /> CP:</h5>
                            <skeleton-text :value="client.cp" :loading="loading" />
                        </div>
                        <div class="col-6 col-lg-3 align-items-left">
                            <h5><fa-icon :icon="['fal', 'earth-europe']" class="mr-1" /> Pais:</h5>
                            <skeleton-text :value="client.country" :loading="loading" />
                        </div>
                    </div>
                </div>

                <div class="card-footer p-0 border-0">
                    <g-map
                        :address="address"
                        :show-header="false"
                        height="300"
                        style="width: 100%; margin-bottom: 0px"
                    />
                </div>
            </div>

            <!-- FACTURACION -->
            <div class="card" v-if="isBoss">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'file-invoice']" :class="['mr-2']" /> Facturación
                    </h5>
                </div>

                <div :class="['card-body', $style.generalCard]">
                    <div class="row mb-4">
                        <div class="col-12 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'credit-card']" class="mr-1" /> Método de pago:</h5>
                            <skeleton-text :value="client.payment_method" :loading="loading">
                                {{ paymentMethod }}
                            </skeleton-text>
                        </div>

                        <div class="col-12 col-lg-4 mb-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'square-dollar']" class="mr-1" /> Tarifa:</h5>
                            <skeleton-text :value="client.rate" :loading="loading">
                                {{ client.rate.text }}
                            </skeleton-text>
                        </div>

                        <div class="col-12 col-lg-4 mb-lg-0">
                            <h5><fa-icon :icon="['fal', 'percent']" class="mr-1" /> Recargo Equivalencia:</h5>
                            <skeleton-text :value="client.surcharge" :loading="loading">
                                <span v-if="client.surcharge === 1" class="text-success bold"> Activado </span>
                                <span v-else class="text-danger bold"> Desactivado </span>
                            </skeleton-text>
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-12 col-lg-4 mb-4 mb-lg-0 align-items-left">
                            <h5><fa-icon :icon="['fal', 'building-columns']" class="mr-1" /> IBAN:</h5>
                            <skeleton-text :value="client.iban" :loading="loading" />
                        </div>
                        <div class="col-12 col-lg-4 mb-lg-0 align-items-left">
                            <h5><fa-icon :icon="['fal', 'input-numeric']" class="mr-1" /> BIC/SWIFT:</h5>
                            <skeleton-text :value="client.bic_swift" :loading="loading" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 mb-lg-0">
                            <h5>
                                <fa-icon :icon="['fal', 'eye']" class="mr-1" /> Mostrar precios:
                                <small v-if="client.show_prices === 1" class="text-success opacity-2"> Activado </small>
                                <small v-else class="text-danger"> Desactivado </small>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sidebar -->
        <div class="col-12 col-lg-4">
            <template v-if="isLoaded">
                <!-- Albaranes -->
                <order-list
                    app="invoices"
                    :view="tableData.invoices_view"
                    title="Ultimos albaranes"
                    :filter="tableData.filter"
                    :more="tableData.more"
                />
                <!-- Facturas -->
                <order-list
                    v-if="isBoss"
                    app="bills"
                    :view="tableData.bills_view"
                    title="Ultimas Facturas"
                    :filter="tableData.filter"
                    :more="tableData.more"
                />
            </template>
        </div>
    </div>
</template>

<script>
// import OrderList from './order-list'

export default {
    name: 'GeneralTab',
    props: {
        client: {
            type: Object,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    computed: {
        isLoaded() {
            const id = this.client._EntityId
            if (id > 0) return true

            return false
        },
        paymentMethod() {
            if (this.$gestios.$utils) {
                const value = this.$gestios.$utils.getValue('clients', 'payment_method', this.client.payment_method)
                return value
            }
            return ''
        },
        address() {
            return `${this.client.address}, ${this.client.location}, ${this.client.cp}`
        },
        tableData() {
            const id = this.client._EntityId

            return {
                invoices_view: `general_invoices_client_${id}`,
                bills_view: `general_bills_client_${id}`,
                more: {
                    field: 'client',
                    value: id,
                },
                filter: [
                    {
                        _ParentOperator: 'OR',
                        _Operator: 'OR',
                        Fields: {
                            client: {
                                type: 3,
                                int: parseInt(id, 10),
                                opt: '=',
                            },
                        },
                    },
                ],
            }
        },
        isBoss() {
            return this.$gestios.profile.BOSS === '1'
        },
    },
    methods: {
        openPDF(item) {
            if (item?.pdf?.Link) {
                window.open(item.pdf.Link, '_blank')
            }
        },
    },
}
</script>

<style lang="scss" module>
.headerIcon {
    font-size: 1.2rem;
    line-height: 1.2rem;
}
.generalCard {
    h5 {
        display: block;
        width: 100%;
    }
}
.rightTable {
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border-radius: 0px !important;
}
.titleBig {
    text-transform: uppercase;
    font-weight: bold;
}
</style>
